// extracted by mini-css-extract-plugin
export var divider = "_df-7";
export var itemsToggle = "_df-8";
export var mergeModal = "_df-1";
export var optionCard = "_df-4";
export var radioGroup = "_df-6";
export var radioOption = "_df-0";
export var selected = "_df-5";
export var shipmentOptions = "_df-2";
export var tableOptions = "_df-3";